// extracted by mini-css-extract-plugin
export default {"inner":"C_inner__qm5no","outer":"C_outer__6MPpt","inner1":"C_inner1__diJgk","inner2":"C_inner2__4wY0i","wrapper":"C_wrapper__9gYyQ"};